import { AdvanceSearchFilterModel } from "../advanceSearchFilterModel";
import { AdvertisementRequestModel } from "../advertisementRequestModel";
import { PagedResult } from "../app/pagedResult";
import { CompanyModel } from "../company/companyModel";

export const INIT_ADVERTISEMENT_REQUEST: AdvertisementRequestModel = {
  companyName: "",
  email: "",
  homeNumber: "",
  message: "",
  choosenPackage: "",
  phoneNumber: "",
  place: "",
  street: "",
  taxId: "",
};

export const INIT_PAGE_SIZE: number = 5;

export const INIT_ADVANCE_SEARCH: AdvanceSearchFilterModel = {
  companyName: "",
  categoryIds: [],
  placeIds: [],
  pageNumber: 1,
  pageSize: INIT_PAGE_SIZE
};

export const INIT_PAGED_RESULT_COMPANY: PagedResult<CompanyModel> = {
  items: [],
  pageNumber: 1,
  pageSize: INIT_PAGE_SIZE,
  totalCount: 0,
  totalPages: 0,
}